function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, FontWeight } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { Alert, Input, Label } from '@keen.io/ui-core';
import SectionTitle from '../../../SectionTitle';
import FieldGroup from '../../../FieldGroup';
import { CurrentValue, InputContainer, FieldsWrapper } from './Gauge.styles';

var GaugeSettings = function GaugeSettings(_ref) {
  var chartSettings = _ref.chartSettings,
      onUpdateChartSettings = _ref.onUpdateChartSettings,
      analysisResult = _ref.analysisResult;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _chartSettings$minVal = chartSettings.minValue,
      minValue = _chartSettings$minVal === void 0 ? 0 : _chartSettings$minVal,
      maxValue = chartSettings.maxValue;

  var _useState = useState({
    minimalValue: minValue.toString(),
    targetValue: (maxValue === null || maxValue === void 0 ? void 0 : maxValue.toString()) || ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = useState({
    hasError: false,
    message: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var minimalValue = values.minimalValue,
      targetValue = values.targetValue;
  var hasError = error.hasError,
      errorMessage = error.message;
  var validateFields = useCallback(function (minimalValue, targetValue) {
    onUpdateChartSettings(_objectSpread(_objectSpread({}, chartSettings), {}, {
      minValue: +minimalValue,
      maxValue: targetValue ? +targetValue : null
    }));
    if (targetValue === '' || targetValue === 'auto') return setError({
      hasError: true,
      message: 'widget_customization_gauge_settings.validation_target_value'
    });
    if (minimalValue === '' || targetValue === 'auto') return setError({
      hasError: true,
      message: 'widget_customization_gauge_settings.validation_minimal_value'
    });
    if (+targetValue <= +minimalValue) return setError({
      hasError: true,
      message: 'widget_customization_gauge_settings.validation'
    });
    setError({
      hasError: false,
      message: ''
    });
  }, [minimalValue, targetValue]);
  return React.createElement("div", null, React.createElement(SectionTitle, {
    title: t('widget_customization_gauge_settings.title')
  }), typeof analysisResult === 'number' && React.createElement(CurrentValue, null, React.createElement(BodyText, {
    variant: "body3",
    color: colors.black[100],
    fontWeight: "normal"
  }, "".concat(t('widget_customization_gauge_settings.current_value'), ": "), React.createElement(FontWeight, {
    fontWeight: "bold"
  }, analysisResult))), React.createElement(FieldsWrapper, null, React.createElement(FieldGroup, null, React.createElement(Label, {
    variant: "secondary",
    hasError: hasError && !minimalValue
  }, t('widget_customization_gauge_settings.minimal_value')), React.createElement(InputContainer, null, React.createElement(Input, {
    placeholder: t('widget_customization_gauge_settings.minimal_value_placeholder'),
    variant: "solid",
    type: "number",
    hasError: hasError && !minimalValue,
    value: minimalValue,
    onKeyDown: function onKeyDown(e) {
      if (e.key === ',') {
        e.preventDefault();
        setError({
          hasError: true,
          message: 'widget_customization_gauge_settings.validation_comma'
        });
      }
    },
    onChange: function onChange(e) {
      e.persist();
      var inputValue = e.currentTarget.value;

      if (!isNaN(inputValue)) {
        setValues(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            minimalValue: inputValue
          });
        });
        validateFields(inputValue, targetValue);
      }
    },
    onBlur: function onBlur() {
      validateFields(minimalValue, targetValue);
    }
  }))), React.createElement(FieldGroup, null, React.createElement(Label, {
    variant: "secondary",
    hasError: hasError && !targetValue
  }, t('widget_customization_gauge_settings.target_value')), React.createElement(InputContainer, null, React.createElement(Input, {
    placeholder: t('widget_customization_gauge_settings.target_value_placeholder'),
    variant: "solid",
    type: "number",
    hasError: hasError && !targetValue,
    value: targetValue,
    onKeyDown: function onKeyDown(e) {
      if (e.key === ',') {
        e.preventDefault();
        setError({
          hasError: true,
          message: 'widget_customization_gauge_settings.validation_comma'
        });
      }
    },
    onChange: function onChange(e) {
      e.persist();
      var inputValue = e.currentTarget.value;

      if (!isNaN(inputValue)) {
        setValues(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            targetValue: inputValue
          });
        });
        validateFields(minimalValue, inputValue);
      }
    },
    onBlur: function onBlur() {
      validateFields(minimalValue, targetValue);
    }
  })))), hasError && React.createElement(Alert, {
    type: "error",
    contentWidth: true
  }, t(errorMessage)));
};

export default GaugeSettings;